/**
 * @group Components
 * 
 * @summary
 * <blockquote>Password input field component for authentication forms.</blockquote>
 * 
 * @example
 * ```tsx
 * <PasswordField
 *   control={form.control}
 *   disabled={isPending}
 * />
 * ```
 */

import type { FieldPath, FieldValues } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../../forms';
import { Input } from '../../forms/Input';
import type { PasswordFieldProps } from './PasswordFieldProps';

/**
 * Password input field component
 */
export function PasswordField<TFieldValues extends FieldValues = FieldValues>({
  control,
  disabled = false,
  name = 'password' as FieldPath<TFieldValues>,
}: PasswordFieldProps<TFieldValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>Password</FormLabel>
          <FormControl>
            <Input 
              placeholder="Enter your password" 
              type="password" 
              disabled={disabled}
              {...field} 
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
